var React = require('react');

function SSearch18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.2,1a6.231,6.231,0,0,1,6.2,6.2A6.455,6.455,0,0,1,12.1,11l4.7,4.7a.778.778,0,1,1-1.1,1.1L11,12.1A6.20081,6.20081,0,0,1,3.4,2.3,6.456,6.456,0,0,1,7.2,1Zm0,10.9a4.695,4.695,0,1,0-3.32487-1.37513A4.7,4.7,0,0,0,7.2,11.9Z","fill":"var(--iconFill, #6e6e6e)"}));
}

SSearch18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SSearch18;

SSearch18.default = SSearch18;
